import { createStyles } from "@mantine/core";

const bgColor = "#fff";

const useStyles = createStyles((theme) => ({
  addMedicationModal: {
    "& .mantine-Drawer-header": { display: "none" },
    "& .mantine-Drawer-root": { overflow: "initial" },
    "& .mantine-Paper-root": {
      overflow: "hidden",
      backgroundColor: bgColor,
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.05)",
      display: "flex",
      flexDirection: "column",
      height: "100%",
    },
    "& .mantine-Drawer-body": { padding: 0, height: "100%" },
    "& .mantine-Input-input": { borderRadius: "8px" },
    "& .mantine-InputWrapper-required": { color: "#000" },
    "& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button":
      { WebkitAppearance: "none", margin: 0 },
    // Prevent iOS Safari from auto-zooming when inputs are focused.
    // iOS zooms any input whose font-size is below 16px; setting it to
    // exactly 16px on mobile disables the zoom without affecting desktop.
    [theme.fn.smallerThan("sm")]: {
      "& .mantine-Input-input, & .mantine-Textarea-input": {
        fontSize: "16px",
      },
    },
  },

  modalBody: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },

  modalTopBar: {
    width: "100%",
    height: "64px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 24px",
    borderBottom: "1px solid rgba(0,0,0,0.08)",
    backgroundColor: "#fff",
    borderRadius: "16px 16px 0 0",
    flexShrink: 0,
    [theme.fn.smallerThan("sm")]: {
      height: "52px",
      padding: "0 14px",
      borderRadius: "0",
    },
  },

  modalTitle: {
    margin: 0,
    fontSize: "24px",
    fontWeight: 700,
    color: "#000",
    fontFamily: "Inter",
    [theme.fn.smallerThan("sm")]: {
      fontSize: "17px",
    },
  },

  modalCloseBtn: {
    background: "none",
    border: "none",
    fontSize: "22px",
    cursor: "pointer",
    color: "#555",
    lineHeight: 1,
    padding: "4px 8px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": { backgroundColor: "rgba(0,0,0,0.06)" },
  },

  clientCard: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,0.1)",
    borderRadius: "12px",
    padding: "12px 18px",
    marginBottom: "24px",
    [theme.fn.smallerThan("sm")]: {
      padding: "10px 12px",
      marginBottom: "16px",
      gap: "10px",
    },
  },

  clientAvatar: {
    width: "46px",
    height: "46px",
    borderRadius: "50%",
    objectFit: "cover",
    flexShrink: 0,
    border: "2px solid #eee",
    [theme.fn.smallerThan("sm")]: {
      width: "36px",
      height: "36px",
    },
  },

  clientInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },

  clientName: {
    margin: 0,
    fontSize: "15px",
    fontWeight: 600,
    color: "#1a1a1a",
    [theme.fn.smallerThan("sm")]: { fontSize: "13px" },
  },

  clientId: {
    margin: 0,
    fontSize: "13px",
    color: "#888",
    [theme.fn.smallerThan("sm")]: { fontSize: "11px" },
  },

  formBox: {
    width: "100%",
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    backgroundColor: "#F5F5F5",
    touchAction: "pan-x pan-y pinch-zoom",
  },

  wrapper: {
    width: "100%",
    padding: "20px 20px 24px",
    display: "flex",
    flexDirection: "column",
    gap: 14,
    [theme.fn.smallerThan("sm")]: {
      padding: "14px 10px",
      gap: 10,
    },
  },

  medContainer: {
    background: "#FCFCFC",
    borderRadius: 16,
    border: "1px solid #E5E5E5",
    padding: "32px 13px",
    [theme.fn.smallerThan("sm")]: {
      padding: "16px 10px",
      borderRadius: 10,
    },
  },

  topFieldsBox: {
    width: "100%",
    display: "flex",
    gap: "17px",
    overflow: "hidden",
    "& .isPrescribed": { flex: 1 },
    "& .isNarcotic": {
      flex: 1,
      "@media (max-width:420px)": { flexDirection: "column" },
    },
    "& .mantine-1ejqehl": { display: "flex", flexDirection: "column" },
    "& .mantine-1cu6yj8:checked": {
      background: "#FFBA45",
      borderColor: "#FFBA45",
    },
    "& .mantine-Radio-radio:checked": {
      background: "#FFBA45",
      borderColor: "#FFBA45",
    },
    [theme.fn.smallerThan("sm")]: {
      flexDirection: "column",
      gap: "12px",
      "& .isPrescribed": {
        borderRight: "none",
        borderBottom: "1px solid rgba(0,0,0,0.08)",
        paddingBottom: "12px",
      },
    },
  },

  inputStyle: {
    flex: 1,
    "& .mantine-Input-wrapper": {
      height: "auto",
      backgroundColor: "#FFFFFF",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        fontFamily: "Inter",
        border: "none",
        backgroundColor: "transparent",
        padding: "10px 14px",
        height: "44px",
        color: "#262626",
      },
      "& .mantine-MultiSelect-input": {
        minHeight: "44px",
        maxHeight: "fit-content",
        height: "100%",
        padding: "0px",
        "& .mantine-MultiSelect-values": {
          minHeight: "inherit",
          padding: "10px 36px 10px 14px",
          "& .mantine-MultiSelect-searchInput": {
            minHeight: "100%",
            height: "100%",
          },
        },
      },
      "& .mantine-Textarea-input": { height: 100, overflowY: "auto" },
      "& .mantine-Select-rightSection svg, .mantine-MultiSelect-rightSection svg":
        { color: "#667085" },
    },
    "& .mantine-DateInput-wrapper, .mantine-DatePickerInput-wrapper": {
      "& .mantine-DateInput-icon, .mantine-DatePickerInput-icon": {
        "& svg": { color: "#262626", fontSize: 18 },
      },
      "& .mantine-DateInput-input, .mantine-DatePickerInput-input": {
        paddingLeft: 36,
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "#262626",
      marginBottom: "6px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },

  radioGroupWrapper: {
    "& .mantine-InputWrapper-label": {
      color: "#262626",
      marginBottom: "6px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
    "& .mantine-Radio-root": { flex: 1 },
  },

  radioGroup: {
    border: "1px solid rgba(0,0,0,0.1)",
    backgroundColor: "#FAFAFA",
    width: "100%",
    height: "auto",
    borderRadius: "10px",
    padding: "14px 20px",
    "& .mantine-Radio-radio:checked": {
      background: "#FFBA45",
      borderColor: "#FFBA45",
    },
    [theme.fn.smallerThan("sm")]: {
      padding: "10px 12px",
    },
  },

  disabledLabel: { color: "gray" },
  normalLabel: { color: "unset" },

  formRow: {
    width: "100%",
    display: "flex",
    gap: "17px",
    marginBlock: "17px",
    [theme.fn.smallerThan("sm")]: {
      flexDirection: "column",
      gap: "12px",
      marginBlock: "12px",
    },
  },

  medicationDosageBox: {
    width: "100%",
    marginBottom: "17px",
    backgroundColor: "#F5F5F5",
    borderRadius: "8px",
    padding: "18px 14px",
    border: "1px solid #D0D5DD",
    "& > p": {
      color: "#171717",
      margin: "0 0 12px 0",
      fontSize: "16px",
      fontWeight: 600,
      fontFamily: "Inter",
    },
    [theme.fn.smallerThan("sm")]: {
      padding: "12px 10px",
      marginBottom: "12px",
      "& > p": { fontSize: "14px" },
    },
  },

  medicationDosageInner: {
    width: "100%",
    display: "flex",
    gap: "15px",
    flexWrap: "wrap",
    "& > div": { flex: "1 1 120px", minWidth: 0 },
    [theme.fn.smallerThan("sm")]: {
      flexDirection: "column",
      gap: "12px",
      "& > div": { flex: "unset", width: "100%" },
    },
  },

  bottomFields: {
    position: "relative",
    backgroundColor: bgColor,
    width: "100%",
    marginBottom: "20px",
    "& input": { backgroundColor: bgColor },
    "& .mantine-Input-input": { backgroundColor: bgColor },
    "& > p": {
      margin: "0",
      color: "#000",
      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "25px",
      marginLeft: "30px",
    },
    "& .dosageHeading": {
      position: "absolute",
      top: -12,
      left: 30,
      zIndex: 100,
      color: "#000",
      margin: 0,
      display: "inline-block",
    },
  },

  bottomFieldsInner: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: "15px",
    padding: "5px 15px 10px 15px",
    borderRadius: "5px",
    "& > div": { flex: "1 1 0", minWidth: 0 },
    "& .mantine-Input-input": { backgroundColor: bgColor },
    "& .mantine-InputWrapper-label": { marginTop: "10px" },
    [theme.fn.smallerThan("sm")]: {
      flexDirection: "column",
      padding: "5px 8px 10px 8px",
    },
  },

  forLabel: {
    "& .mantine-InputWrapper-label": { marginTop: "10px" },
    "& .mantine-Input-input": {
      backgroundColor: "#fff",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
    },
  },

  saveButton: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
    padding: "14px 22px",
    backgroundColor: "#FFFFFF",
    borderTop: "1px solid #E5E5E5",
    flexShrink: 0,
    [theme.fn.smallerThan("sm")]: {
      padding: "12px 14px",
      gap: "8px",
    },
  },

  cancelButton: {
    background: "transparent",
    color: "#262626",
    borderRadius: "8px",
    padding: "10px 18px",
    fontSize: "14px",
    fontWeight: 600,
    border: "none",
    fontFamily: "Inter",
    cursor: "pointer",
    "&:hover": { background: "#F5F5F5" },
  },

  submitButton: {
    borderRadius: "8px",
    background: "#FFAF4A",
    border: "1px solid #FFAF4A",
    color: "#262626",
    padding: "10px 22px",
    fontSize: "14px",
    fontWeight: 600,
    fontFamily: "Inter",
    cursor: "pointer",
    boxShadow: "0 1px 2px 0 rgba(16,24,40,0.05)",
    transition: "background .12s ease",
    "&:hover": { background: "#EEAA33", borderColor: "#EEAA33" },
    "&:disabled": { background: "#E5E5E5", borderColor: "#E5E5E5", color: "#A8A8A8", cursor: "not-allowed", boxShadow: "none" },
  },

  uploadAndDateBox: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    [theme.fn.smallerThan("sm")]: { gap: "14px" },
  },

  dropzone: {
    "& .mantine-Dropzone-root": {
      background: "#fff",
      border: "2px dashed #ccc",
      borderRadius: "12px",
      padding: "20px",
    },
    "& .mantine-Group-root": {
      gap: "0px",
      minHeight: "initial !important",
    },
    width: "100%",
  },

  column: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    gap: "8px",
    width: "100%",
    paddingBlock: "10px",
  },
  dragImage: {
    alignSelf: "center",
    width: "55px",
    height: "55px",
    opacity: 0.5,
    [theme.fn.smallerThan("sm")]: { width: "40px", height: "40px" },
  },
  uploadText: {
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "22px",
    margin: 0,
    textAlign: "center",
    "& span": { color: "#000", textDecoration: "underline", cursor: "pointer" },
    [theme.fn.smallerThan("sm")]: { fontSize: "13px" },
  },
  uploadSubText: {
    fontSize: "12px",
    color: "#aaa",
    margin: 0,
    textAlign: "center",
    marginTop: "4px",
  },

  datePicker: {
    width: "100%",
    "& .mantine-DatePickerInput-input": {
      border: "1px solid rgba(0,0,0,0.1)",
      borderRadius: "8px !important",
    },
    "& label": { fontSize: "0.875rem", fontWeight: 500 },
  },

  fileNameBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    border: "1px solid #ddd",
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "12px 16px",
    marginTop: "10px",
    gap: "12px",
    [theme.fn.smallerThan("sm")]: { padding: "8px 10px", gap: "8px" },
  },
  fileNameLeft: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flex: 1,
    minWidth: 0,
    [theme.fn.smallerThan("sm")]: { gap: "8px" },
  },
  fileNameInfo: { minWidth: 0 },
  fileNameText: {
    margin: 0,
    fontSize: "14px",
    fontWeight: 600,
    color: "#000",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [theme.fn.smallerThan("sm")]: { fontSize: "12px" },
  },
  fileSizeText: {
    margin: 0,
    fontSize: "12px",
    color: "#888",
    [theme.fn.smallerThan("sm")]: { fontSize: "10px" },
  },
  fileNameActions: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexShrink: 0,
  },
  fileViewBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: 4,
    display: "flex",
    alignItems: "center",
  },

  adminScheduleBox: {
    "& .label": {
      fontSize: "0.875rem",
      fontWeight: 500,
      color: "#212529",
      wordBreak: "break-word",
      marginTop: "4px",
      margin: 0,
    },
    "& .mantine-Menu-dropdown": { padding: "1rem" },
    "& .heading": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
  },
  scheduleMenuBtnText: {
    marginTop: "10px",
    color: "#000",
    cursor: "pointer",
    textAlign: "left",
    margin: 0,
    border: "1px solid rgba(0,0,0,0.1)",
    borderRadius: "8px",
    padding: "14px 20px",
    [theme.fn.smallerThan("sm")]: { padding: "10px 14px" },
  },
  monthRepeatBox: {
    color: "black",
    fontSize: "14px",
    borderRadius: "15px",
    margin: "5px 0",
    background: "white",
    height: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  scheduleMenuBox: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    "& h2": { fontSize: "14px", textAlign: "center", margin: 0 },
    "& .footer": {
      display: "flex",
      justifyContent: "flex-end",
      "& button": { backgroundColor: "transparent" },
      "& button:nth-of-type(1)": { color: "black" },
      "& button:nth-of-type(2)": { color: "#FFBA45" },
    },
  },
  repeatEveryBox: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    "& > p": { color: "#979797", fontWeight: 400, margin: 0 },
    "& .mantine-NumberInput-control": {
      border: "transparent",
      color: "#FFBA45",
      backgroundColor: "transparent",
      cursor: "pointer",
    },
  },
  repeatOn: {
    "& > p": { color: "#979797", fontWeight: 400, margin: 0 },
    "& .dayCircleBox": {
      display: "flex",
      gap: "5px",
      marginTop: "10px",
      flexWrap: "wrap",
      "& .dayCircle": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        width: "25px",
        height: "25px",
        cursor: "pointer",
        "& p": { fontSize: "14px", fontWeight: 400, margin: 0, lineHeight: 1 },
      },
      "& .dayCircleActive": {
        backgroundColor: "#FFBA45",
        "& p": { color: "#fff" },
      },
      "& .dayCircleInactive": {
        backgroundColor: "#D9D9D9",
        "& p": { color: "#000" },
      },
    },
  },
  timeslotsParent: {
    alignItems: "center",
    marginTop: 12,
    flexWrap: "wrap",
    maxHeight: 75,
    overflowY: "auto",
    gap: 4,
    "& > p": {
      margin: 0,
      padding: "2px 4px",
      backgroundColor: "#D9D9D9",
      borderRadius: 6,
      fontSize: 12,
    },
  },
  noSpinner: {
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
    MozAppearance: "textfield",
  },

  scheduleDetailsBox: {
    backgroundColor: "#F5F5F5",
    marginTop: "13px",
    border: "1px solid #D0D5DD",
    borderRadius: "8px",
    padding: "18px 14px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    [theme.fn.smallerThan("sm")]: {
      padding: "12px 10px",
      gap: "10px",
    },
  },
}));

export default useStyles;
